import { apimCall } from './../helpers/api';
import { getQuerystringParameters } from './../helpers/utility';
import { showBanner } from '../helpers/MessageUtility';
import { RootState } from '../gf-types';
import { getProfile } from '../profile/actions';
import { GoFormzServices } from '../AppSettings';
import { analyticsTrack } from '../helpers/AnalyticsUtility';
import { SubscriptionState } from './subscription-types';
import { NavigateFunction } from 'react-router-dom';

export const SUBSCRIPTION_INIT = 'SUBSCRIPTION_INIT';
export const SUBSCRIPTION_RESET = 'SUBSCRIPTION_RESET';
export const SUBSCRIPTION_GET_REQUEST = 'SUBSCRIPTION_GET_REQUEST';
export const SUBSCRIPTION_GET_SUCCESS = 'SUBSCRIPTION_GET_SUCCESS';
export const SUBSCRIPTION_GET_FAILURE = 'SUBSCRIPTION_GET_FAILURE';
export const SUBSCRIPTION_DOWNGRADE_REQUEST = 'SUBSCRIPTION_DOWNGRADE_REQUEST';
export const SUBSCRIPTION_DOWNGRADE_SUCCESS = 'SUBSCRIPTION_DOWNGRADE_SUCCESS';
export const SUBSCRIPTION_DOWNGRADE_FAILURE = 'SUBSCRIPTION_DOWNGRADE_FAILURE';
export const SUBSCRIPTION_UPDATE_REQUEST = 'SUBSCRIPTION_UPDATE_REQUEST';
export const SUBSCRIPTION_UPDATE_SUCCESS = 'SUBSCRIPTION_UPDATE_SUCCESS';
export const SUBSCRIPTION_UPDATE_FAILURE = 'SUBSCRIPTION_UPDATE_FAILURE';

export const getSubscription = () => async (dispatch) => {
  try {
    dispatch({
      type: SUBSCRIPTION_GET_REQUEST,
      payload: {
        fetching: true
      }
    });
    const response = await apimCall<SubscriptionState>(GoFormzServices.AccountService, `/subscriptions`);

    dispatch({
      type: SUBSCRIPTION_GET_SUCCESS,
      payload: response.data
    });
  } catch (err) {
    dispatch({
      type: SUBSCRIPTION_GET_FAILURE,
      payload: { errorMessage: err }
    });
  }
};

export const downgradeSubscription = (newEditionCode) => async (dispatch, getState: () => RootState) => {
  dispatch({ type: SUBSCRIPTION_DOWNGRADE_REQUEST });
  try {
    const state: RootState = getState();
    await apimCall(GoFormzServices.AccountService, '/subscriptions', 'PUT', {
      editionCode: newEditionCode,
      promoCode: state.subscription?.promoCode,
      addOnsToRemove: state.subscription?.activeAddOns,
      addOnsToAdd: []
    });
    dispatch({
      type: SUBSCRIPTION_DOWNGRADE_SUCCESS,
      payload: {
        downgradeSuccess: true,
        upgradeSuccess: false,
        updateSuccess: false
      }
    });
    // now that the subscription is updated we need to reload the profile and subscription info
    await getProfile()(dispatch);
    await getSubscription()(dispatch);
    showBanner('Subscription has been updated');
  } catch (err) {
    dispatch({ type: SUBSCRIPTION_DOWNGRADE_FAILURE });
  }
};

export const resetSubscriptionPage = () => ({
  type: SUBSCRIPTION_RESET
});

export const initSubscriptionPage = (navigate: NavigateFunction) => (dispatch) => {
  const params = getQuerystringParameters(true);

  navigate('/subscription');

  dispatch({
    type: SUBSCRIPTION_INIT,
    payload: {
      upgradeSuccess: params.upgradesuccess,
      downgradeSuccess: params.downgradesuccess,
      updateSuccess: params.updatesuccess
    }
  });

  getSubscription()(dispatch);
};

export const cancelPendingSubscription = () => async (dispatch, getState: () => RootState) => {
  dispatch({
    type: SUBSCRIPTION_UPDATE_REQUEST,
    payload: { isUpdating: true }
  });

  const state: RootState = getState();

  try {
    await apimCall(GoFormzServices.AccountService, '/subscriptions', 'PUT', {
      editionCode: state.subscription?.editionCode,
      licensedUserCount: state.subscription?.licensedUserCount,
      promoCode: state.subscription?.promoCode,
      addOnsToAdd: state.subscription?.activeAddOns,
      addOnsToRemove: []
    });

    dispatch({
      type: SUBSCRIPTION_UPDATE_SUCCESS,
      payload: {
        isUpdating: false,
        updateSuccess: true,
        downgradeSuccess: false,
        upgradeSuccess: false,
        pendingEditionCode: null,
        pendingEditionName: null
      }
    });
    await getProfile()(dispatch);
    await getSubscription()(dispatch);
    showBanner('Subscription change has been cancelled');
    analyticsTrack('Pending Changes Cancelled', {});
  } catch (err) {
    console.error(err);
    dispatch({
      type: SUBSCRIPTION_UPDATE_FAILURE,
      payload: { isUpdating: false },
      errorMessage: err.response ? err.response.data : 'There was an error'
    });
  }
};
